import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@core/services';
import { LoggerService } from '@core/services/logger/logger.service';
import { ApiErrorResponse } from '@shared/models';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);
  const loggerService = inject(LoggerService);

  return next(req).pipe(
    catchError((error: ApiErrorResponse) => {
      if ([401, 403].includes(error.status)) {
        authService.logout();
        return EMPTY;
      }

      let apiError = { ...error.error };

      if (!apiError.message) {
        const message = 'Server error. Please try again later.';
        apiError = { ...apiError, message };
      }

      const logMessage = `Error Code: ${error.status}\nMessage: ${error.message}\nApi error: ${apiError.message}`;
      const stackTrace = apiError.stack || '';

      loggerService.error(logMessage, stackTrace);

      return throwError(() => apiError);
    }),
  );
};
